import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FarmHouse} from '@/common/interface/farm-overview.data';
import {Router, RouterModule} from '@angular/router';

@Component({
    selector: 'app-farm-overview-house-view',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './farm-overview-house-view.component.html',
    styleUrl: './farm-overview-house-view.component.scss'
})
export class FarmOverviewHouseViewComponent {
    @Input() house!: FarmHouse;
    @Input() houseId?: number | string;

    expanded: boolean = true;
    constructor(private router: Router) {}

    toggleExpand(): void {
        this.expanded = !this.expanded;
    }

    openHouseDetails(): void {
        const id = this.house.houseId;
        this.router.navigate(['/house-detail', id]);
    }
}
